import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map, List } from 'immutable';

import { Filter } from './Filter';
import { Sorter } from './Sorter';
import { Spinner } from '../../helpers/Spinner';

/**
 * Stateless component for showing filter panel.
 *
 * @param props {Object}.
 * @param props.sorts {Immutable.Map} List of sorting items.
 * @param props.typeFilters {Immutable.Map} Approach type filters data.
 * @param props.mailFilters {Immutable.Map} Mailing filters data.
 * @param props.activityFilters {Immutable.Map} Activity filters data.
 * @param props.userFilters {Immutable.Map} User type filters data.
 * @param props.onChangeSort {Function} To handle changing a sorting field.
 * @param props.onChangeOrder {Function} To handle changing sorting order.
 * @param props.isFetching {Boolean} Show spinner icon when set to true.
 */
const SettingPanelComponent = ({ sorts, onChangeSort, onChangeOrder, isFetching, ...rest }) => {
  const spinner = isFetching ? <Spinner className="spinner--block" /> : null;

  return (
    <div>
      <Sorter onChangeOrder={onChangeOrder} onChangeSort={onChangeSort} sorts={sorts} />
      <Filter {...rest} />
      {spinner}
    </div>
  );
};

SettingPanelComponent.propTypes = {
  activityFilters: PropTypes.instanceOf(Map),
  isFetching: PropTypes.bool.isRequired,
  mailFilters: PropTypes.instanceOf(Map),
  onChangeOrder: PropTypes.func.isRequired,
  onChangeSort: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  sorts: PropTypes.instanceOf(List),
  typeFilters: PropTypes.instanceOf(Map),
  userFilters: PropTypes.instanceOf(Map),
};

export const SettingPanel = memo(SettingPanelComponent);
